import React from 'react';
import { TextField, Button, InputAdornment } from '@mui/material';

function SearchBar({ label, searchQuery, setSearchQuery, handleSearch }) {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div>
            <TextField
                variant="outlined"
                label={label}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleKeyDown}  // Add the onKeyDown handler
                size="small"
                sx={{ mt: 1, mb: 1, width: '100%' }}
                InputProps={{
                    sx: {
                        color: searchQuery ? 'black' : 'gray',
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#478F96',
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#478F96',
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#478F96',
                        },
                        padding: 1,
                    },
                    endAdornment: (
                        <InputAdornment position="end">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSearch}
                                sx={{ padding: 1, borderRadius: 1.5 }}
                            >
                                <p style={{ fontWeight: 600, margin: 0, padding: '0 40px' }}>ค้นหา</p>
                            </Button>
                        </InputAdornment>
                    ),
                }}
                InputLabelProps={{
                    sx: {
                        color: 'gray',
                        padding: 1,
                    },
                }}
            />
        </div>
    );
}

export default SearchBar;
